module.exports = __webpack_public_path__ + "img/logo-portal.758c9efe.svg";